import React, { useCallback } from 'react';

import IconButton from '@material-ui/core/IconButton';
import ArrowIcon from '@material-ui/icons/KeyboardArrowLeft';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

import EditIcon from '../../../assets/icons/EditIcon';
import PhoneIcon from '../../../assets/icons/PhoneIcon';
import MailIcon from '../../../assets/icons/MailIcon';
import QualificationIcon from '../../../assets/icons/QualificationIcon';
import LinkedInIcon from '../../../assets/icons/LinkedInIcon';
import WebsiteIcon from '../../../assets/icons/WebsiteIcon';

import Button from '../../shared/Button';
import Select from '../../shared/Select';

import { getCommaSeparatedNames } from '../../../utils/table';

import './surgeon-page.scss';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: 8
  }
}));

const getExternalUrl = (url = '') => {
  if (!url) {
    return '';
  }

  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

const SurgeonInfo = (props) => {
  const {
    surgeon,
    onBackClick,
    onEditClick,
    view,
    setView,
    options = [],
    procedures = [],
    hospitals = [],
    qualifications = [],
  } = props;

  const classes = useStyles();

  const getQualificationNames = useCallback((ids) => getCommaSeparatedNames(qualifications, ids) || '---', [qualifications]);

  const getProcedureNames = useCallback((ids) => getCommaSeparatedNames(procedures, ids), [procedures]);

  const getHospitalName = useCallback((hospitalId) => {
    const hospital = hospitals?.find((hospital) => hospital.id === hospitalId);
    return hospital ? hospital.name : '';
  }, [hospitals]);

  return (
    <div className='surgeon-info__container'>
      <div className='surgeon-info__actions'>
        <div className='d-flex'>
          <IconButton
            className="m-r-md"
            onClick={onBackClick}
            size="small"
          >
            <ArrowIcon fontSize="large" />
          </IconButton>
          <div className="d-flex flex-1">
            <Tooltip
              title="Edit Surgeon"
              aria-label="edit-surgeon"
              classes={{ tooltip: classes.tooltip }}
            >
              <div className="m-l-md">
                <Button
                  type="icon"
                  onClick={onEditClick}
                >
                  <EditIcon color="var(--app-text)" />
                </Button>
              </div>
            </Tooltip>
          </div>
        </div>

        <div className="m-l-md">
          <Select
            value={view}
            onChange={setView}
            options={options}
          />
        </div>
      </div>

      <div className='surgeon-info__surgeon-info'>
        <div className='font-bold'>
          {surgeon ? `${surgeon.title} ${surgeon.firstName} ${surgeon.lastName}` : ''}
        </div>
        <div className='surgeon-info__contact-details m-t-lg'>
          <div className='surgeon-info__contact-detail surgeon-info__contact-detail--full'>
            <QualificationIcon color="var(--app-text)" />
            <div className='m-l-md'>{getQualificationNames(surgeon?.qualifications)}</div>
          </div>
          <div className='surgeon-info__contact-detail'>
            <PhoneIcon color="var(--app-text)" />
            <div className='m-l-md'>{surgeon?.phone || '---'}</div>
          </div>
          <div className='surgeon-info__contact-detail'>
            <MailIcon color="var(--app-text)" />
            <div className='m-l-md'>{surgeon?.email || '---'}</div>
          </div>
          <div className='surgeon-info__contact-detail'>
            <LinkedInIcon color="var(--app-text)" />
            {surgeon?.linkedin ? (
              <a
                className='m-l-md'
                href={getExternalUrl(surgeon.linkedin)}
                target='_blank'
                rel='noreferrer'
              >
                LinkedIn
              </a>
            ) : (
              <div className='m-l-md'>---</div>
            )}
          </div>
          <div className='surgeon-info__contact-detail'>
            <WebsiteIcon color="var(--app-text)" />
            {surgeon?.website ? (
              <a
                className='m-l-md'
                href={getExternalUrl(surgeon.website)}
                target='_blank'
                rel='noreferrer'
              >
                Website
              </a>
            ) : (
              <div className='m-l-md'>---</div>
            )}
          </div>
        </div>
      </div>

      <div className='surgeon-info__procedures-hospitals'>
        <div className='font-bold'>Procedures</div>
        <div className='m-t-sm'>
          {getProcedureNames(surgeon?.procedures)}
        </div>

        <div className='font-bold m-t-md'>Hospitals</div>
        {surgeon?.hospitals?.map((hospitalId) => (
          <div key={hospitalId} className='m-t-sm'>{getHospitalName(hospitalId)}</div>
        ))}
      </div>
    </div>
  );
};

export default SurgeonInfo;
